import { render, staticRenderFns } from "./VcitaCombobox.vue?vue&type=template&id=9d06f920&scoped=true"
import script from "./VcitaCombobox.vue?vue&type=script&lang=js"
export * from "./VcitaCombobox.vue?vue&type=script&lang=js"
import style0 from "./VcitaCombobox.vue?vue&type=style&index=0&id=9d06f920&prod&lang=scss&scoped=true"
import style1 from "./VcitaCombobox.vue?vue&type=style&index=1&id=9d06f920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d06f920",
  null
  
)

export default component.exports